module.exports = __webpack_public_path__ + "img/certTempBr.b872c029.png";